/* =========================================================
   BILIPING 11/10 POLISH JS (OPTIMIZED FOR PAGESPEED)
   Safe UX helpers only. No Shopify cart/product logic changed.
   - Eliminated Forced Reflows using requestAnimationFrame
   - Throttled Scroll and Debounced Resize events
========================================================= */
(function () {
  if (window.Biliping1110Polish) return;
  window.Biliping1110Polish = true;

  var root = document.documentElement;
  var body = document.body;

  // 1. Skrol logika optimizovana sa requestAnimationFrame
  var tickingScroll = false;
  function onScroll() {
    if (!tickingScroll) {
      window.requestAnimationFrame(function () {
        if (document.body) {
          document.body.classList.toggle('bp-has-scrolled', window.scrollY > 8);
        }
        tickingScroll = false;
      });
      tickingScroll = true;
    }
  }

  // 2. Grupisanje kalkulacija ekrana da zaustavimo Forced Reflow
  function updateLayoutMetrics() {
    window.requestAnimationFrame(function () {
      // READS (Prvo samo očitavamo vrijednosti)
      var w = window.innerWidth || root.clientWidth;
      var h = window.innerHeight || root.clientHeight;
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      var portrait = h >= w;
      var phone = w <= 899;
      var tabletPortrait = coarse && portrait && w >= 600 && w <= 1100;
      var mobileMode = phone || tabletPortrait;
      var vhValue = (h * 0.01) + 'px';

      // WRITES (Zatim sve upisujemo odjednom)
      root.style.setProperty('--bp-vh', vhValue);
      root.classList.toggle('bp-phone-theme', mobileMode);
      root.classList.toggle('bp-desktop-theme', !mobileMode);
      root.classList.toggle('bp-tablet-portrait-mobile', tabletPortrait);
      root.classList.toggle('bp-tablet-landscape-desktop', coarse && !portrait && w >= 900 && w <= 1200);
    });
  }

  function markLoadedImages() {
    document.querySelectorAll('img:not(.bp-img-loaded)').forEach(function (img) {
      if (img.complete) {
        img.classList.add('bp-img-loaded');
      } else {
        img.addEventListener('load', function () {
          img.classList.add('bp-img-loaded');
        }, { once: true });
      }
    });
  }

  function boot() {
    body = document.body;
    updateLayoutMetrics();
    onScroll();
    markLoadedImages();
  }

  // Inicijalizacija bez blokiranja renderovanja
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // 3. Debounce za promjenu veličine ekrana (čuva CPU)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateLayoutMetrics, 150);
  }, { passive: true });

  window.addEventListener('orientationchange', function () {
    setTimeout(updateLayoutMetrics, 150);
  }, { passive: true });

  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', boot);
})();